var map = {
	"./adc.svg": "/iMx",
	"./cannes.svg": "u0Wv",
	"./clio.svg": "hfG1",
	"./die_klappe.svg": "HV4k",
	"./dnad.svg": "Dopd",
	"./effie.svg": "umsq",
	"./epica.svg": "uJxi",
	"./eurobest.svg": "NJ4n",
	"./grammy.svg": "jVzi",
	"./lia.svg": "3vg5",
	"./lovie.svg": "/uZH",
	"./max.svg": "orSU",
	"./one_show.svg": "7OVc",
	"./ramses.svg": "DBLp",
	"./raw.svg": "XHfU",
	"./spotlight.svg": "oeph",
	"./webby.svg": "eQb4",
	"./yda.svg": "Ohxg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sp/L";